export default function WhoShouldTest() {
  const signs = [
    {
      icon: 'ri-focus-3-line',
      title: 'Difficulty Focusing',
      description: 'Struggling to concentrate on tasks, easily distracted by surroundings or thoughts, difficulty completing projects or following through on commitments.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Impulsivity',
      description: 'Acting without thinking, interrupting others frequently, making hasty decisions without considering consequences, difficulty waiting your turn.'
    },
    {
      icon: 'ri-calendar-schedule-line',
      title: 'Time Management Issues',
      description: 'Chronic lateness, underestimating how long tasks take, difficulty prioritizing, procrastination on important tasks, missing deadlines regularly.'
    },
    {
      icon: 'ri-run-line',
      title: 'Restlessness',
      description: 'Feeling constantly on edge, inability to relax, fidgeting or tapping, difficulty sitting still for extended periods, always feeling the need to move.'
    },
    {
      icon: 'ri-question-line',
      title: 'Forgetfulness',
      description: 'Frequently losing items, forgetting appointments or commitments, difficulty remembering instructions, missing important details in conversations.'
    },
    {
      icon: 'ri-emotion-line',
      title: 'Emotional Regulation',
      description: 'Quick mood changes, difficulty managing frustration, overreacting to minor setbacks, trouble controlling emotional responses in various situations.'
    }
  ];

  return (
    <section id="who-should-test" className="py-24 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-violet-600 font-semibold text-sm uppercase tracking-wide">Is This You?</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Signs You May Benefit<br />From ADHD Testing
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Millions of adults live with undiagnosed ADHD. Recognizing these signs is the first step toward getting the help you need.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {signs.map((sign, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-stone-100"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-violet-100 rounded-2xl mb-5">
                <i className={`${sign.icon} text-2xl text-violet-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{sign.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{sign.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-gray-700 mb-6">
            <strong>Experiencing multiple symptoms?</strong> An ADHD assessment can provide clarity and open doors to effective treatment options.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block bg-violet-600 text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Schedule Your Assessment
          </button>
        </div>
      </div>
    </section>
  );
}
